import { render, staticRenderFns } from "./SettingAndUser.vue?vue&type=template&id=4e6add78&scoped=true"
import script from "./SettingAndUser.vue?vue&type=script&lang=js"
export * from "./SettingAndUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6add78",
  null
  
)

export default component.exports